<template>
  <div>
    <el-card>
      <!--基础信息-->
      <div style="font-size: 14px; color: #606266">
        <span>No：{{ formData.fabricStockOutNo }}</span>
        <el-divider direction="vertical"></el-divider>
        <span>Status：{{ formData.fabricStockOutStatusName }}</span>
        <el-divider direction="vertical"></el-divider>
        <span>
          Create：{{ formData.createByName }} at
          {{ formData.createDate }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span>
          Modify：{{ formData.modifyByName }} at
          {{ formData.modifyDate }}
        </span>
      </div>
      <div class="d2-mt">
        <el-form ref="formData" :model="formData" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="$l('label_applicant') || '申请人'"
                prop="requestAgentCode"
              >
                <dict-select
                  :disabled="disabled"
                  v-model="formData.requestAgentCode"
                  url="/digitalCenter/common/dict/baseUser"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  size="small"
                  style="width: 100%"
                  filterable
                  :multiple="false"
                  clearable
                  :options="{ label: 'label', value: 'code' }"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('label_date_application') || '申请日期'"
                prop="requestDate"
              >
                <el-date-picker
                  :disabled="disabled"
                  clearable
                  v-model="formData.requestDate"
                  :picker-options="requestDatePicker"
                  type="date"
                  value-format="yyyy-MM-dd"
                  size="small"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('label_delivery_date') || '出库日期'"
                prop="outStockDate"
              >
                <el-date-picker
                  :disabled="disabled"
                  clearable
                  v-model="formData.outStockDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  size="small"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                :label="$l('label_fabric_usage') || '面料用途'"
                prop="requestUse"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.requestUse"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  maxlength="4000"
                  clearable
                  size="medium"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 3 }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('label_notes') || '备注说明'"
                prop="outStockMemo"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.outStockMemo"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  clearable
                  size="medium"
                  maxlength="4000"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 3 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div>
          <detail-data
            ref="detailData"
            :disabled="disabled"
            :tableData="tableData"
          />
        </div>
        <!--按钮-->
        <el-row class="d2-mt">
          <el-col :span="20">
            <el-button
              @click="save"
              v-if="!disabled"
              size="mini"
              type="primary"
              >{{ $l('INDEX.btn_save') || '保存' }}</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import DetailData from './components/list.vue'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  components: {
    DetailData,
  },
  data() {
    return {
      requestDatePicker: this.requestDateEnd(),
      params: {
        fabricStockOutCode: '',
      },
      pageHeader: '',
      dialogVisible: false,
      disabled: false,
      tableData: [],
      formData: {
        fabricStockOutCode: '',
        fabricStockOutNo: '',
        requestAgentCode: '',
        requestAgentName: '',
        requestAgentDeptCode: '',
        requestAgentDeptName: '',
        requestUse: '',
        requestDate: '',
        outStockDate: '',
        outStockMemo: '',
        companyCode: '',
        fabricStockOutStatus: '',
        fabricStockOutStatusName: '',
        createBy: '',
        createByName: '',
        createDate: '',
        modifyBy: '',
        modifyByName: '',
        modifyDate: '',
        auditBy: '',
        auditByName: '',
        auditDate: '',
      },
      type: '',
      rules: {
        requestAgentCode: [
          {
            required: true,
            message: '请选择申请人',
            trigger: 'blur',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'blur',
          },
        ],
        outStockDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.params.fabricStockOutCode) {
      let type = this.$route.params.pageType
      let fabricStockOutCode = this.$route.params.fabricStockOutCode
      this.init(type, fabricStockOutCode)
    }
  },
  activated() {
    if (this.$route.params.fabricStockOutCode) {
      let type = this.$route.params.pageType
      let fabricStockOutCode = this.$route.params.fabricStockOutCode
      this.init(type, fabricStockOutCode)
    }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    requestDateEnd() {
      return {
        disabledDate(time) {
          return new Date().getTime() < time.getTime()
        },
      }
    },
    init(type, fabricStockOutCode) {
      this.reset()
      if (type === 'edit') {
        this.type = type
        this.updateLoad(fabricStockOutCode)
      } else if (type === 'detail') {
        this.type = type
        this.detailLoad(fabricStockOutCode)
      } else if (type === 'add') {
        this.type = type
        this.addLoad()
      }
    },
    updateLoad(fabricStockOutCode) {
      this.pageHeader = this.$l('page_name_fcadm') || '面料领用出库修改'
      this.disabled = false
      let param = { fabricStockOutCode: fabricStockOutCode }
      this.loadData(param)
    },
    detailLoad(fabricStockOutCode) {
      this.pageHeader = this.$l('page_name_fcadd') || '面料领用出库详情'
      this.disabled = true
      let param = { fabricStockOutCode: fabricStockOutCode }
      this.loadData(param)
    },
    loadData(param) {
      this.loadingOpen()
      this.$api
        .fabricStockOutDetailApi(param)
        .then((res) => {
          this.loadingClose()
          this.formData = res.body
          this.tableData = res.body.listDetail
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    addLoad() {
      this.pageHeader = this.$l('page_name_nfcad') || '面料领用出库新增'
      this.disabled = false
    },
    save() {
      const form = this.$refs.formData
      const getDetailData = this.$refs.detailData.getTableData()
      if (getDetailData.length < 1) {
        this.$message.warning('请选择库存面料')
        return false
      }
      try {
        getDetailData.forEach((item, index) => {
          let requestQuantity = parseFloat(item.requestQuantity)
          let outQuantity = parseFloat(item.outQuantity)
          let rowNumber = index + 1
          if (outQuantity === 0) {
            let msg = '第【' + rowNumber + '】行，出库数量等于0'
            throw new Error(msg)
          }
          if (requestQuantity < outQuantity) {
            let msg = '第【' + rowNumber + '】行，出库数量大于库存数量'
            throw new Error(msg)
          }
        })
      } catch (e) {
        this.$message.warning(e.message)
        return
      }
      this.formData.listDetail = getDetailData
      validate.formValidate([form], (valid) => {
        if (valid) {
          this.loadingOpen()
          this.$api
            .fabricStockOutSaveApi(this.formData)
            .then(() => {
              this.loadingClose()
              this.saveOkQuestion()
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    reset() {
      this.$refs.formData.resetFields()
      this.type = ''
      this.dialogVisible = false
      this.formData = {
        fabricStockOutCode: '',
        fabricStockOutNo: '',
        requestAgentCode: '',
        requestAgentName: '',
        requestAgentDeptCode: '',
        requestAgentDeptName: '',
        requestUse: '',
        requestDate: '',
        outStockDate: '',
        outStockMemo: '',
        companyCode: '',
        fabricStockOutStatus: '',
        fabricStockOutStatusName: '',
        createBy: '',
        createByName: '',
        createDate: '',
        modifyBy: '',
        modifyByName: '',
        modifyDate: '',
        auditBy: '',
        auditByName: '',
        auditDate: '',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
